import { X } from "@phosphor-icons/react";
import styled from "@emotion/styled";
import { Button } from "@/components/primitives/Button";
import type { TableBulkActionsProps } from "./DataTable.types";

/* Exact compiled output of the pre-migration Tailwind utilities. */

const TableBulkActionsRoot = styled("div", {
  label: "AgenticTableBulkActions-root"
})({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  gap: ".5rem",
  borderBottomWidth: "1px",
  "--tw-border-opacity": "1",
  borderColor: "hsl(var(--bfrs-color-border) / var(--tw-border-opacity, 1))",
  "--tw-bg-opacity": "1",
  backgroundColor: "hsl(var(--bfrs-color-primary-soft) / var(--tw-bg-opacity, 1))",
  paddingLeft: "1.25rem",
  paddingRight: "1.25rem",
  paddingTop: ".5rem",
  paddingBottom: ".5rem"
});

const TableBulkActionsLabel = styled("span", {
  label: "AgenticTableBulkActions-label"
})({
  fontSize: ".875rem",
  lineHeight: "1.25rem",
  fontWeight: 600,
  "--tw-text-opacity": "1",
  color: "hsl(var(--bfrs-color-success-contrast) / var(--tw-text-opacity, 1))"
});

const TableBulkActionsSpacer = styled("div", {
  label: "AgenticTableBulkActions-spacer"
})({
  minWidth: ".5rem",
  flex: "1 1 0%"
});

export function TableBulkActions({ selectedCount, actions, onClearSelection, label, className }: TableBulkActionsProps) {
  if (selectedCount <= 0) return null;

  return (
    <TableBulkActionsRoot className={className}>
      <TableBulkActionsLabel>{label ?? `${selectedCount} selected`}</TableBulkActionsLabel>
      {actions}
      <TableBulkActionsSpacer />
      {onClearSelection && (
        <Button variant="secondary" size="sm" leftIcon={<X size={13} />} onClick={onClearSelection}>
          Clear selection
        </Button>
      )}
    </TableBulkActionsRoot>
  );
}
